import Overlay from './Overlay';
import OverlayContainer from './Overlay.container';

export default OverlayContainer(Overlay);
